import { render } from "./About.vue?vue&type=template&id=5ae75396"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=5ae75396&lang=css"
script.render = render

export default script